import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, fetchUtils } from 'react-admin';
import Constants from './../shared/constants';
import {getAuthApp} from './security/authApp';
import { encrypt, decrypt } from './security/encryptorHandlerSecurity';
import UserHelper from '../helpers/UserHelper';
import 'whatwg-fetch';

const deletedToken = async (user) =>{
    const urlGet = `${Constants.general.serverURL}/api/my-users/${user.userId}/accessTokens`;
    return await fetch(urlGet, {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json', 'Authorization' : getAuthApp()}
                })
                .then(response => {
                  if (!response.ok) throw new Error('Error con el token');
                  return true;
                })
}
const createdToken = async (user) =>{
    const urlGet = `${Constants.general.serverURL}/api/my-users/${user.userId}/accessTokens`;
    return await fetch(urlGet, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization' : getAuthApp()}
                })
                .then(response => {
                if (response.ok) return response.json();
                throw new Error('Error con el token');
                }).then(data=>{
                    return data;
                })
}
const validateToken = async(user) =>{
    const urlGet = `${Constants.general.serverURL}/api/my-users/${user.userId}/accessTokens`;    
    return await fetch(urlGet, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json', 'Authorization' : getAuthApp()}
                })
                .then(response => {
                   /* if(response.status === 200 && response.ok === true) return true;
                    return false;*/
                    return response.json();
                }).then(data=>{
                    return data.length
                });
}
export default async (type, params) => {   
    // called when the user attempts to log in
    if (type === AUTH_LOGIN) {
        const { username, password } = params;
        const url = `${Constants.general.serverURL}/api/my-users/login`;
        const data = JSON.stringify({
            "email": username,
            "password": password
        }, null, 2);

        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : getAuthApp()
            },
            body: data
        })
        .then(response => {
            if (!response.ok) {
                return Promise.reject('Usuario o contraseña incorrectos');
            }
            
            return response.json();
        })
        .then(async(user) => {
            let v1 = await validateToken(user);
            if(v1 != 1){
            let vd=await deletedToken(user);
            if(vd === true) user = await createdToken(user);
            if(vd !== true)  return Promise.reject();
            }
            // login successful if there's a jwt token in the response
            if (user.id) {
                const urlGet = `${Constants.general.serverURL}/api/my-users/${user.userId}`;
                return fetch(urlGet, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json', 'Authorization' : getAuthApp()}
                })
                .then(response => {
                    if (!response.ok) {
                        // return Promise.reject(response.statusText);
                    }
                    return response.json();
                })
                .then(userInfo => {
                    user.info = userInfo;
                    let fakeUser = {};
                    fakeUser.valid = null;
                    let d = new Date();
                    const n = encrypt(d.toLocaleDateString()+'-AdminLoti-');
                    const v = Math.floor(Math.random()*5);
                   // localStorage.setItem('userAdminLoti', JSON.stringify(user));
                    for (let index = 0; index < 5; index++) {
                        for (let key of Object.keys(user)) {
                            if( typeof user[key] === 'number' )
                            fakeUser[key]=Math.floor(Math.random()*9999)+100;
                            if(typeof user[key] === 'string'){
                            fakeUser[key]=encrypt('fail Login'); 
                            }else{
                            fakeUser[key]=encrypt('fail Login'); 
                            }
                        }
                        if(v !== index){
                        localStorage.setItem(encrypt(d.toLocaleDateString()+'-Failed-'+index), encrypt(JSON.stringify(fakeUser)));
                        }else{
                        localStorage.setItem(n, encrypt(JSON.stringify(user)));
                        fakeUser.valid = n;
                        localStorage.setItem(encrypt(d.toLocaleDateString()+'-Validate-'+index), encrypt(JSON.stringify(fakeUser)));
                        fakeUser.valid = null;
                        }

                    }
                    return Promise.resolve();
                })
                .catch(error => {
                    //return Promise.reject(error);
                });
            }else{
                return Promise.reject();
            }
        })
        .catch(error => {
            return Promise.reject(error);
        });

    }
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        //localStorage.removeItem('userAdminLoti');
        const v = await UserHelper.validateLocal();
        const user = v !== null ? JSON.parse(decrypt(localStorage.getItem(v))):null;
        if(user !== null)
        await deletedToken(user);
        localStorage.clear();
        return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const { status, message } = params;
        if (status === 401 || status === 403 ) {
            const v = await UserHelper.validateLocal();
            const user = v !== null ? JSON.parse(decrypt(localStorage.getItem(v))):null;
            //localStorage.removeItem('userAdminLoti');
            if(user !== null)
            await deletedToken(user);
            localStorage.clear();
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        const { resource } = params;
        const v = await UserHelper.validateLocal();
        if (localStorage.getItem(v)) {
            const user = JSON.parse(decrypt(localStorage.getItem(v)));
            if( new Date(user.created.replace('Z', '')).getTime() >= new Date().getTime()) {
                if (resource === 'my-users' || resource === 'user-types'){
                    return (user.info.typeId === 2) ? Promise.resolve() : Promise.reject();
                } else {
                    return Promise.resolve();
                }
            } else {
                return Promise.reject();
            }

        } else {
            return Promise.reject();
        }
    }
    return Promise.reject('Unknown method');
};